export const services = [
  {
    id: 1,
    slug: 'ui-ux-design',
    title: "UI/UX Design",
    category: "User-Centric Designs",
    image: "https://images.unsplash.com/photo-1602576666092-bf6447a729fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxVSSUyMGRlc2lnbnxlbnwwfHx8fDE3NjE4NjY4NjR8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    slug: 'blockchain-development',
    title: "Blockchain Development",
    category: "Decentralized Security",
    image: "https://images.unsplash.com/photo-1666816943035-15c29931e975?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxibG9ja2NoYWluJTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3NjE4NjY4Njl8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    slug: 'ecommerce-development',
    title: "E-commerce Development",
    category: "Sales Optimization",
    image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxlY29tbWVyY2V8ZW58MHx8fHwxNzYxODY2OTE5fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    slug: 'web-development',
    title: "Web Development",
    category: "Dynamic Websites",
    image: "https://images.unsplash.com/photo-1457305237443-44c3d5a30b89?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHx3ZWIlMjBkZXZlbG9wbWVudHxlbnwwfHx8fDE3NjE4NjY4NzR8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 5,
    slug: 'custom-software-development',
    title: "Custom Software Development",
    category: "Scalable Solutions",
    image: "https://images.unsplash.com/photo-1593720213428-28a5b9e94613?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHx3ZWIlMjBkZXZlbG9wbWVudHxlbnwwfHx8fDE3NjE4NjY4NzR8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 6,
    slug: 'mobile-app-development',
    title: "Mobile App Development",
    category: "Intuitive Apps",
    image: "https://images.unsplash.com/photo-1551650975-87deedd944c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxtb2JpbGUlMjBhcHB8ZW58MHx8fHwxNzYxODY2ODc4fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 7,
    slug: '3d-animation',
    title: "3D Animation",
    category: "Immersive Visuals",
    image: "https://images.unsplash.com/photo-1633356122544-f134324a6cee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODN8MHwxfHNlYXJjaHwxfHwzZCUyMGFuaW1hdGlvbnxlbnwwfHx8fDE3NjE4NjY5MzR8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 8,
    slug: 'cloud-solutions',
    title: "Cloud Solutions",
    category: "Scalable Infrastructure",
    image: "https://images.pexels.com/photos/1148820/pexels-photo-1148820.jpeg"
  },
  {
    id: 9,
    slug: 'digital-marketing',
    title: "Digital Marketing Solution",
    category: "Targeted Growth",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxkaWdpdGFsJTIwbWFya2V0aW5nfGVufDB8fHx8MTc2MTg2Njg4OXww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 10,
    slug: 'creative-copywriting',
    title: "Creative Copywriting",
    category: "Engaging Content",
    image: "https://images.unsplash.com/photo-1455390582262-044cdead277a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxjcmVhdGl2ZSUyMHdyaXRpbmd8ZW58MHx8fHwxNzYxODY2OTQ5fDA&ixlib=rb-4.1.0&q=85"
  }
];

export const serviceDetails = [
  {
    id: 'ui-ux-design',
    title: "UI/UX Design",
    category: "User-Centric Designs",
    image: "https://images.unsplash.com/photo-1602576666092-bf6447a729fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxVSSUyMGRlc2lnbnxlbnwwfHx8fDE3NjE4NjY4NjR8MA&ixlib=rb-4.1.0&q=85",
    shortDescription: "Creating intuitive and visually stunning interfaces that enhance user experience and drive engagement.",
    description: "Our UI/UX design services focus on creating user-centered digital experiences that are both beautiful and functional. We combine research, strategy, and creative design to craft interfaces that delight users and achieve business goals.",
    detailedDescription: "We follow a comprehensive design process that includes user research, wireframing, prototyping, and testing. Our designers work closely with your team to understand your brand, users, and business objectives, ensuring every design decision is purposeful and impactful.",
    features: [
      { title: "User Research & Analysis", description: "In-depth research to understand your target audience and their needs." },
      { title: "Wireframing & Prototyping", description: "Interactive prototypes to visualize and test design concepts." },
      { title: "Visual Design", description: "Stunning visual interfaces that align with your brand identity." },
      { title: "Usability Testing", description: "Comprehensive testing to ensure optimal user experience." }
    ],
    benefits: [
      "Increased user engagement and satisfaction",
      "Higher conversion rates and customer retention",
      "Reduced development costs through early validation",
      "Stronger brand identity and market differentiation",
      "Improved accessibility and usability across devices"
    ],
    technologies: ["Figma", "Adobe XD", "Sketch", "InVision", "Principle", "Framer", "Miro", "Zeplin"],
    pricing: [
      {
        name: 'Basic UI/UX Package',
        price: '$499',
        features: [
          'Up to 5 Pages/Screens',
          'Basic Wireframing',
          'Simple UI Mockups',
          'Basic UX Strategy',
          'Standard Typography & Colors',
          '1 Free Revision',
          'Delivery in 5-7 Days',
          'Dedicated Project Manager',
        ]
      },
      {
        name: 'Startup UI/UX Package',
        price: '$1,499',
        features: [
          'Up to 15 Pages/Screens',
          'Advanced Wireframing',
          'Fully Custom UI Mockups',
          'Basic User Research',
          'Basic Competitive Analysis',
          'Advanced UX Strategy',
          'Fully Responsive Across All Devices',
          'Custom Typography & Color Schemes',
          'Basic Usability Testing',
          'Basic A/B Testing',
          'Basic Design System',
          '3 Free Revisions',
          'Delivery in 7-14 Days',
          'Dedicated UI/UX Team',
        ]
      },
      {
        name: 'Professional UI/UX Package',
        price: '$2,999',
        features: [
          'Up to 30 Pages/Screens',
          'High-Fidelity Wireframes',
          'Interactive Prototypes',
          'In-Depth User Research & Persona Development',
          'Comprehensive Competitive Analysis',
          'Data-Driven UX Optimization',
          'Cross-Platform Compatibility (Web, Mobile, Tablets)',
          'AI-Powered Color & Design Optimization',
          'Advanced UI Animations & Motion Design',
          'Full Usability Testing with Real Users',
          'Multi-Variant A/B Testing',
          'ADA & WCAG Certified Accessibility Features',
          'Full-Scale Design System with Reusable Components',
          'Unlimited Revisions',
          'Delivery in 14-21 Days',
          'Dedicated UI/UX Team & 24/7 Support',
        ]
      },
    ],

  },
  {
    id: 'blockchain-development',
    title: "Blockchain Development",
    category: "Decentralized Security",
    image: "https://images.unsplash.com/photo-1666816943035-15c29931e975?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxibG9ja2NoYWluJTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3NjE4NjY4Njl8MA&ixlib=rb-4.1.0&q=85",
    shortDescription: "Building secure, transparent, and decentralized solutions powered by blockchain technology.",
    description: "Our blockchain development services help businesses leverage distributed ledger technology to create secure, transparent, and efficient systems. From smart contracts to decentralized applications, we deliver enterprise-grade blockchain solutions.",
    detailedDescription: "We specialize in developing custom blockchain solutions tailored to your specific needs. Whether you need a private blockchain network, smart contract development, or integration with existing systems, our team has the expertise to deliver secure and scalable solutions.",
    features: [
      { title: "Smart Contract Development", description: "Automated, self-executing contracts with enhanced security." },
      { title: "DApp Development", description: "Decentralized applications built on blockchain platforms." },
      { title: "Blockchain Integration", description: "Seamless integration with existing business systems." },
      { title: "Tokenization Solutions", description: "Create and manage digital tokens and assets." }
    ],
    benefits: [
      "Enhanced security and data integrity",
      "Transparent and immutable transaction records",
      "Reduced operational costs and intermediaries",
      "Improved traceability and accountability",
      "Automated processes through smart contracts"
    ],
    technologies: ["Ethereum", "Solidity", "Hyperledger", "Web3.js", "Truffle", "Hardhat", "IPFS", "Polygon"],
    pricing: [
      {
        name: 'Basic Blockchain Package',
        price: '$4,999',
        features: [
          'Private Blockchain Setup',
          'Up to 3 Smart Contracts',
          'Basic dApp Development',
          'Token Development (ERC-20 or BEP-20)',
          'Basic Wallet Integration',
          'Basic Security Protocols',
          'Basic Performance Optimization',
          'Dedicated Project Manager',
          '100% Ownership Rights',
        ]
      },
      {
        name: 'Startup Blockchain Package',
        price: '$9,999',
        features: [
          'Custom Blockchain Development',
          'Up to 10 Smart Contracts',
          'Advanced dApp with UI/UX',
          'Custom Token Development (ERC, BEP, Solana, etc.)',
          'Basic NFT Marketplace Setup',
          'AI-Based Blockchain Analytics',
          'Advanced Encryption & Security',
          'Cross-Chain Compatibility',
          'Basic DAO Governance Setup',
          'Basic DeFi App Integration',
          'Basic Web3 Connectivity',
          'Limited API & Oracle Integration',
          'Speed & Efficiency Optimization',
          'Custom Enterprise Blockchain Solutions',
          'Dedicated Blockchain Team',
          '100% Ownership Rights',
        ]
      },
      {
        name: 'Professional Blockchain Package',
        price: '$19,999',
        features: [
          'Enterprise-Grade Blockchain Solutions',
          'Unlimited Smart Contracts',
          'Full-Scale Decentralized Platform',
          'Multi-Chain Token & Asset Management',
          'Custom Wallet with Multi-Chain Support',
          'Fully Functional NFT Marketplace',
          'AI & Machine Learning-Driven Blockchain System',
          'Enterprise-Level Cybersecurity & Threat Protection',
          'Multi-Chain & Layer-2 Scaling Solutions',
          'Fully Automated DAO Development',
          'Full DeFi Ecosystem (Lending, Staking, Yield Farming)',
          'Web3.0 Integration with AI & IoT',
          'Custom API Development & Oracle Connectivity',
          'Full Regulatory Compliance & Legal Assistance',
          'Advanced Performance Tuning with AI',
          'Enterprise-Level Blockchain Development & Maintenance',
          'Dedicated Blockchain Team & 24/7 Support',
          '100% Ownership Rights',
        ]
      },
    ],

  },
  {
    id: 'ecommerce-development',
    title: "E-commerce Development",
    category: "Sales Optimization",
    image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxlY29tbWVyY2V8ZW58MHx8fHwxNzYxODY2OTE5fDA&ixlib=rb-4.1.0&q=85",
    shortDescription: "Developing powerful e-commerce platforms that drive sales and deliver exceptional shopping experiences.",
    description: "We build feature-rich, scalable e-commerce solutions that help businesses sell online effectively. From custom shopping carts to payment integration, we create platforms that convert visitors into customers.",
    detailedDescription: "Our e-commerce development services cover everything from storefront design to backend systems, payment processing, inventory management, and analytics. We ensure your online store is fast, secure, and optimized for conversions.",
    features: [
      { title: "Custom Storefront Design", description: "Beautiful, responsive designs that showcase your products." },
      { title: "Payment Gateway Integration", description: "Secure payment processing with multiple payment options." },
      { title: "Inventory Management", description: "Real-time inventory tracking and management systems." },
      { title: "Shopping Cart Optimization", description: "Streamlined checkout process to reduce cart abandonment." }
    ],
    benefits: [
      "Increased online sales and revenue",
      "Enhanced customer experience and satisfaction",
      "Automated order processing and fulfillment",
      "Better inventory management and control",
      "Detailed analytics and sales insights"
    ],
    technologies: ["Shopify", "WooCommerce", "Magento", "Stripe", "PayPal", "React", "Node.js", "MongoDB"],
    pricing: [
      {
        name: 'Basic E-commerce Package',
        price: '$1,599',
        features: [
          'Up to 10 Product Listings',
          'Pre-Designed Template',
          'Single Payment Gateway',
          'Basic Shopping Cart',
          'Standard Checkout Process',
          'Basic Security Features',
          'Dedicated Project Manager',
          '100% Ownership Rights',
        ]
      },
      {
        name: 'Startup E-commerce Package',
        price: '$2,999',
        features: [
          'Up to 50 Product Listings',
          'Custom UI/UX Design',
          'Multiple Payment Gateways',
          'Advanced Shopping Cart',
          'Basic Inventory System',
          'One-Page Checkout',
          'Limited Multi-Vendor Functionality',
          'Basic Customer Account System',
          'Basic CRM Integration',
          'Basic Order Tracking',
          'Basic SEO Setup',
          'Social Media Login & Sharing',
          'Third-Party API Integration',
          'Basic Sales Reports',
          'SSL Security & Data Encryption',
          'Mobile-Optimized Store',
          'Dedicated Project Manager',
          '100% Ownership Rights',
        ]
      },
      {
        name: 'Professional E-commerce Package',
        price: '$4,999',
        features: [
          'Unlimited Product Listings',
          'Fully Customized Design & Layout',
          'Advanced Payment System (Subscriptions, Installments, Crypto)',
          'Smart Cart with AI Recommendations',
          'Multi-Warehouse Inventory Management',
          'Custom Checkout with Upselling Features',
          'Full Multi-Vendor Marketplace Support',
          'Advanced User Profiles & Loyalty Program',
          'Advanced CRM & AI Chatbot Support',
          'Real-Time Order & Delivery Tracking',
          'Advanced SEO & Performance Optimization',
          'Omnichannel Social Commerce Integration',
          'Custom API & ERP System Integration',
          'AI-Driven Business Analytics & Insights',
          'Advanced Cybersecurity & Fraud Protection',
          'Custom Mobile App (iOS & Android)',
          'Dedicated Development Team & Business Consultant',
          '100% Ownership Rights',
        ]
      },
    ],

  },
  {
    id: 'web-development',
    title: "Web Development",
    category: "Dynamic Websites",
    image: "https://images.unsplash.com/photo-1457305237443-44c3d5a30b89?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHx3ZWIlMjBkZXZlbG9wbWVudHxlbnwwfHx8fDE3NjE4NjY4NzR8MA&ixlib=rb-4.1.0&q=85",
    shortDescription: "Creating modern, responsive websites that captivate audiences and drive business growth.",
    description: "Our web development services deliver high-performance, scalable websites that provide exceptional user experiences. We use cutting-edge technologies to build websites that are fast, secure, and optimized for search engines.",
    detailedDescription: "From corporate websites to complex web applications, we develop solutions that meet your business objectives. Our full-stack developers handle everything from frontend design to backend infrastructure, ensuring seamless functionality.",
    features: [
      { title: "Responsive Design", description: "Websites that work flawlessly across all devices and screen sizes." },
      { title: "Performance Optimization", description: "Lightning-fast load times and smooth user interactions." },
      { title: "SEO Optimization", description: "Built-in SEO best practices to improve search rankings." },
      { title: "CMS Integration", description: "Easy content management with popular CMS platforms." }
    ],
    benefits: [
      "Professional online presence and credibility",
      "Improved search engine visibility",
      "Better user engagement and conversion rates",
      "Mobile-friendly and accessible design",
      "Easy content updates and management"
    ],
    technologies: ["React", "Next.js", "Vue.js", "Node.js", "Python", "PHP", "WordPress", "MySQL"],
    pricing: [
      {
        name: 'Basic Website Package',
        price: '$499',
        features: [
          '3 Page Website',
          'Custom Layout Design',
          'Contact/Query Form',
          '1 Banner Design',
          '2 Stock Photos',
          'FREE Favicon Design',
          'Cross Browser Compatible',
          'Complete W3C Certified HTML',
          'Website Initial Concepts in 48 Hours',
          'Complete Design & Deployment',
          'Complete Source Files',
          'Dedicated Project Manager',
          '100% Ownership Rights',
          '100% Satisfaction Guarantee',
          '100% Money Back Guarantee',
        ]
      },
      {
        name: 'Startup Website Package',
        price: '$899',
        features: [
          '5 Page Website',
          'Custom Layout Design',
          'Contact/Query Form',
          '3 Banner Designs',
          '5 Stock Photos',
          'FREE Favicon Design',
          'FREE Google Friendly Sitemap',
          'Unlimited Revisions',
          'Complete W3C Certified HTML',
          'Website Initial Concepts in 48 Hours',
          'Complete Design & Deployment',
          'Complete Source Files',
          'Dedicated Project Manager',
          '100% Ownership Rights',
          '100% Satisfaction Guarantee',
          '100% Money Back Guarantee',
        ]
      },
      {
        name: 'Professional Website Package',
        price: '$1,499',
        features: [
          'Up to 10 Unique Pages Website',
          'CMS /Admin Panel Integration',
          '5+ Stock Photos & Banner Designs',
          'FREE Social Media Integration',
          'FREE Favicon Design',
          'FREE Google Friendly Sitemap',
          'Unlimited Revisions',
          'Cross Browser Compatible',
          'Complete W3C Certified HTML',
          'Website Initial Concepts in 48 Hours',
          'Complete Design & Deployment',
          'Custom, Interactive & Dynamic Web Design',
          'Industry specified Team of Expert Designers and Developers',
          'Complete Source Files',
          'Dedicated Project Manager',
          '100% Ownership Rights',
          '100% Satisfaction Guarantee',
          '100% Money Back Guarantee',
        ]
      },
    ],

  },
  {
    id: 'custom-software-development',
    title: "Custom Software Development",
    category: "Scalable Solutions",
    image: "https://images.unsplash.com/photo-1593720213428-28a5b9e94613?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHx3ZWIlMjBkZXZlbG9wbWVudHxlbnwwfHx8fDE3NjE4NjY4NzR8MA&ixlib=rb-4.1.0&q=85",
    shortDescription: "Tailored software solutions designed to meet your unique business requirements and challenges.",
    description: "We develop custom software applications that streamline operations, improve efficiency, and give you a competitive advantage. Our solutions are built to scale with your business and adapt to changing needs.",
    detailedDescription: "Our custom software development process includes detailed requirement analysis, architecture design, development, testing, and deployment. We use agile methodologies to ensure transparency and deliver high-quality software on time.",
    features: [
      { title: "Requirements Analysis", description: "Thorough understanding of your business processes and needs." },
      { title: "Scalable Architecture", description: "Flexible architecture that grows with your business." },
      { title: "API Development", description: "Robust APIs for integration with third-party systems." },
      { title: "Quality Assurance", description: "Comprehensive testing to ensure reliability and performance." }
    ],
    benefits: [
      "Increased operational efficiency",
      "Automated business processes",
      "Better data management and insights",
      "Competitive advantage through innovation",
      "Long-term cost savings"
    ],
    technologies: ["Python", "Java", "C#", ".NET", "React", "Angular", "PostgreSQL", "Docker"],
    pricing: [
      {
        name: 'Basic Software Package',
        price: '$2,499',
        features: [
          'Up to 3 Core Features/Modules',
          'Basic User Interface',
          'Single Platform (Web or Desktop)',
          'Standard Functionalities',
          'Limited User Management',
          'Basic Security Features',
          'Dedicated Project Manager',
          'Free Software Logo',
        ]
      },
      {
        name: 'Startup Software Package',
        price: '$4,999',
        features: [
          'Up to 7 Advanced Features/Modules',
          'Custom UI/UX Design',
          'Cross-Platform (Web & Desktop)',
          'Advanced Functionalities',
          'Secure User Management & Authentication',
          'Basic Payment Gateway Integration',
          'Third-Party API Integration',
          'Basic Reporting Dashboard',
          'Basic Automation Features',
          'Cloud Hosting Setup',
          'Basic CRM Integration',
          'Basic Admin Control Panel',
          'SSL Security & Encryption',
          'Dedicated Project Manager',
          'Free Software Logo & UI Kit',
        ]
      },
      {
        name: 'Professional Software Package',
        price: '$9,999',
        features: [
          'Fully Custom & Scalable Software',
          'Advanced UI/UX with Interactive Elements',
          'Web, Desktop & Mobile Compatibility',
          'AI & Automation Integration',
          'Multi-Level User Access & Role-Based Permissions',
          'Advanced Multi-Payment & Subscription Systems',
          'Custom API & Enterprise System Integrations',
          'AI-Powered Analytics & Insights',
          'Intelligent Process Automation',
          'Advanced Cloud Computing & Dedicated Servers',
          'Advanced CRM & ERP System Integration',
          'Custom Admin Dashboard with Advanced Controls',
          'Advanced Cybersecurity & Compliance',
          'Dedicated Development Team & Business Analyst',
          'Free Branding Kit & UI/UX Prototyping',
        ]
      },
    ],

  },
  {
    id: 'mobile-app-development',
    title: "Mobile App Development",
    category: "Intuitive Apps",
    image: "https://images.unsplash.com/photo-1551650975-87deedd944c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxtb2JpbGUlMjBhcHB8ZW58MHx8fHwxNzYxODY2ODc4fDA&ixlib=rb-4.1.0&q=85",
    shortDescription: "Building innovative mobile applications for iOS and Android that engage users and drive results.",
    description: "Our mobile app development services deliver intuitive, high-performance applications that provide exceptional user experiences. We build native and cross-platform apps that leverage device capabilities and modern features.",
    detailedDescription: "From concept to launch, we handle every aspect of mobile app development. Our team creates apps that are not only visually appealing but also fast, secure, and easy to use, ensuring high user retention and engagement.",
    features: [
      { title: "Native App Development", description: "High-performance apps for iOS and Android platforms." },
      { title: "Cross-Platform Development", description: "Cost-effective solutions that work on multiple platforms." },
      { title: "UI/UX Design", description: "Intuitive interfaces optimized for mobile devices." },
      { title: "App Store Optimization", description: "Strategies to improve visibility and downloads." }
    ],
    benefits: [
      "Direct engagement with mobile users",
      "Enhanced brand visibility and loyalty",
      "Push notifications for better engagement",
      "Offline functionality and device integration",
      "Revenue generation through mobile commerce"
    ],
    technologies: ["Swift", "Kotlin", "React Native", "Flutter", "Firebase", "Realm", "Xcode", "Android Studio"],
    pricing: [
      {
        name: 'Basic App Package',
        price: '$1,999',
        features: [
          'Up to 5 App Screens',
          'Basic UI/UX Design',
          'Android OR iOS App',
          'Standard Features',
          'Basic Navigation',
          'Push Notifications',
          'Basic User Authentication',
          'Play Store OR App Store Submission',
          'Dedicated Project Manager',
          'Free App Icon',
          '100% Ownership Rights',
        ]
      },
      {
        name: 'Startup App Package',
        price: '$3,999',
        features: [
          'Up to 10 App Screens',
          'Custom UI/UX Design',
          'Android & iOS App',
          'Advanced Features',
          'Smooth Navigation',
          'Push Notifications',
          'Secure User Authentication',
          'Payment Gateway Integration',
          'Basic API Integration',
          'In-App Chat',
          'Social Media Integration',
          'Admin Panel',
          'Play Store & App Store Submission',
          'Dedicated Project Manager',
          'Free App Icon & Splash Screen',
          '100% Ownership Rights',
        ]
      },
      {
        name: 'Professional App Package',
        price: '$7,499',
        features: [
          'Up to 20 App Screens',
          'Premium UI/UX with Animations',
          'Android & iOS App',
          'Fully Custom & Scalable App',
          'Advanced Navigation with Animations',
          'AI-Powered Push Notifications',
          'Multi-Level Security & Biometric Authentication',
          'Multi-Payment & Subscription Integration',
          'Custom API & Third-Party Integrations',
          'AI Chatbot & Voice Assistant',
          'Social Media, CRM & Analytics Integration',
          'Full Custom Admin Dashboard',
          'Complete Deployment & Optimization',
          'Dedicated Team with a Business Analyst',
          'Free App Icon, Splash Screen & UI Animations',
          '100% Ownership Rights',
        ]
      },
    ],

  },
  {
    id: '3d-animation',
    title: "3D Animation",
    category: "Immersive Visuals",
    image: "https://images.unsplash.com/photo-1633356122544-f134324a6cee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODN8MHwxfHNlYXJjaHwxfHwzZCUyMGFuaW1hdGlvbnxlbnwwfHx8fDE3NjE4NjY5MzR8MA&ixlib=rb-4.1.0&q=85",
    shortDescription: "Creating stunning 3D animations and visual effects that captivate audiences and tell compelling stories.",
    description: "Our 3D animation services bring ideas to life with photorealistic visuals, engaging characters, and immersive environments. We create animations for marketing, training, product visualization, and entertainment.",
    detailedDescription: "Using industry-leading software and techniques, we produce high-quality 3D animations that meet the highest standards. From concept art to final rendering, we ensure every frame is crafted with attention to detail.",
    features: [
      { title: "Character Animation", description: "Lifelike character movements and expressions." },
      { title: "Product Visualization", description: "Photorealistic 3D models of your products." },
      { title: "Architectural Visualization", description: "Stunning visualizations of buildings and spaces." },
      { title: "Motion Graphics", description: "Dynamic animations for branding and marketing." }
    ],
    benefits: [
      "Enhanced visual communication",
      "Better product presentations",
      "Increased engagement and retention",
      "Cost-effective alternative to live-action",
      "Unlimited creative possibilities"
    ],
    technologies: ["Blender", "Maya", "3ds Max", "Cinema 4D", "After Effects", "Unity", "Unreal Engine", "V-Ray"],
    pricing: [
      {
        name: 'Basic 3D Animation Package',
        price: '$1,499',
        features: [
          'Up to 30-Second Animation',
          'Basic Character Modeling',
          'Simple 3D Environment',
          'Basic Rigging & Animation',
          'Basic Texturing & Lighting',
          'Standard 30 FPS Rendering',
          '1 Free Revision',
          'Delivery in 10-14 Days',
          'Dedicated Project Manager',
        ]
      },
      {
        name: 'Startup 3D Animation Package',
        price: '$2,999',
        features: [
          'Up to 60-Second Animation',
          'Advanced Character Modeling',
          'Custom 3D Environment',
          'Advanced Rigging & Motion Capture',
          'Realistic Texturing & Advanced Lighting',
          'Basic Storyboarding',
          'Standard Voiceover',
          'Basic Special Effects',
          'High-Quality 60 FPS Rendering',
          'Basic AR/VR Compatibility',
          '3 Free Revisions',
          'Delivery in 21-30 Days',
          'Dedicated 3D Animation Team',
        ]
      },
      {
        name: 'Professional 3D Animation Package',
        price: '$3,999',
        features: [
          'Up to 120-Second Animation',
          'Hyper-Realistic Character Modeling',
          'High-Detail, Cinematic 3D Environment',
          'High-End Rigging with Facial Animation',
          'Industry-Grade Texturing & Dynamic Lighting',
          'Full Pre-Production Storyboarding',
          'Premium Voiceover & Sound FX',
          'High-End VFX & Post-Production Editing',
          '4K Cinematic Rendering',
          'Full AR/VR Ready Animation',
          'Unlimited Revisions',
          'Delivery in 45+ Days',
          'Dedicated Animation & VFX Team',
        ]
      },
    ],

  },
  {
    id: 'cloud-solutions',
    title: "Cloud Solutions",
    category: "Scalable Infrastructure",
    image: "https://images.pexels.com/photos/1148820/pexels-photo-1148820.jpeg",
    shortDescription: "Delivering secure, scalable cloud infrastructure that powers modern businesses and applications.",
    description: "Our cloud solutions help businesses leverage the power of cloud computing for improved scalability, reliability, and cost-efficiency. We design and implement cloud architectures that support your growth.",
    detailedDescription: "From migration to ongoing management, we provide comprehensive cloud services across AWS, Azure, and Google Cloud. Our solutions ensure high availability, disaster recovery, and optimal performance for your applications.",
    features: [
      { title: "Cloud Migration", description: "Seamless migration of applications and data to the cloud." },
      { title: "Infrastructure Management", description: "24/7 monitoring and management of cloud resources." },
      { title: "Security & Compliance", description: "Enterprise-grade security and compliance solutions." },
      { title: "Cost Optimization", description: "Strategies to reduce cloud costs while maintaining performance." }
    ],
    benefits: [
      "Reduced infrastructure costs",
      "Improved scalability and flexibility",
      "Enhanced disaster recovery capabilities",
      "Better collaboration and remote access",
      "Automatic updates and maintenance"
    ],
    technologies: ["AWS", "Azure", "Google Cloud", "Kubernetes", "Docker", "Terraform", "CloudFormation", "Jenkins"],
    pricing: [
      {
        name: 'Basic Cloud Solutions Package',
        price: '$899',
        features: [
          'Up to 100GB Cloud Storage',
          'Shared Cloud Hosting',
          'Standard Data Backup (Daily)',
          'Basic Cloud Security',
          'Cloud-Based File Sharing',
          'Basic Database Integration',
          'Standard Cloud Migration',
          'Email & Chat Support',
          '1 Free Revision',
          'Delivery in 7-10 Days',
          'Dedicated Project Manager',
        ]
      },
      {
        name: 'Startup Cloud Solutions Package',
        price: '$1,499',
        features: [
          'Up to 500GB Cloud Storage',
          'Dedicated Cloud Hosting',
          'Automated Data Backup & Recovery',
          'Advanced Security & Encryption',
          'Team Collaboration Tools',
          'Advanced Database Management',
          'Full Cloud Migration & Setup',
          'Standard API Integrations',
          '24/7 Technical Support',
          '3 Free Revisions',
          'Delivery in 14-21 Days',
          'Cloud Infrastructure Specialist',
        ]
      },
      {
        name: 'Professional Cloud Solutions Package',
        price: '$2,999',
        features: [
          'Unlimited Cloud Storage',
          'Enterprise-Grade Cloud Infrastructure',
          'Real-Time Backup & Disaster Recovery',
          'AI-Powered Threat Detection & Firewall',
          'Multi-User Cloud Access with Admin Controls',
          'High-Performance Database Optimization',
          'Multi-Cloud Strategy & Hybrid Cloud Solutions',
          'Custom API Development & Integration',
          'Priority Enterprise Support',
          'Unlimited Revisions',
          'Delivery in 30-45 Days',
          'Full Cloud Engineering Team',
        ]
      },
    ],

  },
  {
    id: 'digital-marketing',
    title: "Digital Marketing Solution",
    category: "Targeted Growth",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxkaWdpdGFsJTIwbWFya2V0aW5nfGVufDB8fHx8MTc2MTg2Njg4OXww&ixlib=rb-4.1.0&q=85",
    shortDescription: "Data-driven digital marketing strategies that increase visibility, drive traffic, and generate leads.",
    description: "Our digital marketing services combine strategy, creativity, and analytics to help businesses reach their target audience and achieve measurable results. From SEO to social media marketing, we cover all aspects of digital marketing.",
    detailedDescription: "We develop comprehensive marketing strategies tailored to your business goals. Our team uses the latest tools and techniques to optimize campaigns, track performance, and maximize ROI across all digital channels.",
    features: [
      { title: "Search Engine Optimization", description: "Improve organic search rankings and visibility." },
      { title: "Social Media Marketing", description: "Engage audiences across social media platforms." },
      { title: "Content Marketing", description: "Create valuable content that attracts and converts." },
      { title: "Analytics & Reporting", description: "Track performance and optimize campaigns." }
    ],
    benefits: [
      "Increased brand awareness and visibility",
      "Higher quality leads and conversions",
      "Better customer engagement",
      "Measurable ROI and performance metrics",
      "Competitive advantage in digital space"
    ],
    technologies: ["Google Analytics", "SEMrush", "Ahrefs", "HubSpot", "Mailchimp", "Hootsuite", "Google Ads", "Facebook Ads"],
    pricing: [
      {
        name: 'Basic Digital Marketing Package',
        price: '$799',
        features: [
          '5 Social Media Posts (Facebook, Instagram, LinkedIn)',
          '1 Social Media Ad Campaign',
          'Google My Business Setup & Optimization',
          '5 Keywords SEO Optimization',
          'Basic On-Page SEO',
          '1 Blog Post (500 Words)',
          'Email Marketing (1 Campaign)',
          'PPC Setup & Basic Campaign',
          'Monthly Performance Report',
          'Website Speed Optimization',
          'Basic Influencer Outreach',
          '1 Free Revision',
          'Dedicated Account Manager',
        ]
      },
      {
        name: 'Startup Digital Marketing Package',
        price: '$2,499',
        features: [
          '15 Social Media Posts (Facebook, Instagram, LinkedIn, Twitter)',
          '3 Social Media Ad Campaigns',
          'Google My Business + Yelp Optimization',
          '15 Keywords SEO Optimization',
          'Advanced On-Page & Technical SEO',
          '4 Blog Posts (1,000 Words Each)',
          'Email Marketing (3 Campaigns)',
          'PPC Setup & Management (Google & Facebook)',
          'Weekly Performance Report',
          'Website & Landing Page Optimization',
          'Influencer Marketing Strategy',
          '3 Free Revisions',
          'Digital Marketing Strategist',
        ]
      },
      {
        name: 'Professional Digital Marketing Package',
        price: '$5,999',
        features: [
          '30+ Social Media Posts (All Major Platforms)',
          '6 Social Media Ad Campaigns',
          'Full Local SEO & Business Directory Listings',
          '50+ Keywords SEO Optimization',
          'Full SEO Audit & Strategy',
          '8+ Blog Posts (1,500+ Words Each)',
          'Advanced Email Marketing & Automation',
          'PPC with A/B Testing & Conversion Optimization',
          'Real-Time Analytics & Reporting Dashboard',
          'Full Conversion Rate Optimization (CRO)',
          'Advanced Influencer Collaboration',
          'Unlimited Revisions',
          'Full Marketing Team Support',
        ]
      },
    ],

  },
  {
    id: 'creative-copywriting',
    title: "Creative Copywriting",
    category: "Engaging Content",
    image: "https://images.unsplash.com/photo-1455390582262-044cdead277a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxjcmVhdGl2ZSUyMHdyaXRpbmd8ZW58MHx8fHwxNzYxODY2OTQ5fDA&ixlib=rb-4.1.0&q=85",
    shortDescription: "Crafting compelling copy that connects with audiences, tells your story, and drives action.",
    description: "Our creative copywriting services deliver persuasive, engaging content that resonates with your target audience. From website copy to marketing materials, we create words that work.",
    detailedDescription: "We combine storytelling, psychology, and marketing expertise to craft copy that not only sounds great but also achieves your business objectives. Every word is chosen to engage, inform, and convert.",
    features: [
      { title: "Website Copywriting", description: "Compelling copy that converts visitors into customers." },
      { title: "Brand Messaging", description: "Consistent voice and messaging across all channels." },
      { title: "Marketing Materials", description: "Brochures, case studies, and promotional content." },
      { title: "SEO Content Writing", description: "Content optimized for search engines and users." }
    ],
    benefits: [
      "Stronger brand identity and voice",
      "Increased engagement and conversions",
      "Better communication with target audience",
      "Improved SEO and search rankings",
      "Professional and polished brand image"
    ],
    technologies: ["Grammarly", "Hemingway", "Copyscape", "Google Docs", "Jasper AI", "Surfer SEO", "Yoast", "ContentKing"],
    pricing: [
      {
        name: 'Basic Copywriting Package',
        price: '$499',
        features: [
          '5 Website Content Pages',
          '3 Blog Posts (500 Words Each)',
          '5 Social Media Captions',
          '1 Email Newsletter',
          'Basic SEO Optimization',
          '2 Ad Copies (Google/Facebook)',
          '1 Press Release (400 Words)',
          'Product Descriptions (Up to 5 Products)',
          'Brand Story & About Us Page',
          '1 Revision',
          'Dedicated Copywriter',
        ]
      },
      {
        name: 'Startup Copywriting Package',
        price: '$1,499',
        features: [
          '10 Website Content Pages',
          '6 Blog Posts (1,000 Words Each)',
          '20 Social Media Captions',
          '3 Email Campaigns',
          'SEO-Optimized Copywriting',
          '5 Ad Copies (Google/Facebook/LinkedIn)',
          '2 Press Releases (600 Words Each)',
          'Product Descriptions (Up to 15 Products)',
          'Brand Story, About Us, and Mission Page',
          '3 Revisions',
          'Senior Copywriter',
        ]
      },
      {
        name: 'Professional Copywriting Package',
        price: '$2,199',
        features: [
          '20+ Website Content Pages',
          '12+ Blog Posts (1,500+ Words Each)',
          '50+ Social Media Captions',
          'Full Email Marketing Strategy',
          'Advanced SEO & Keyword Strategy',
          '10+ High-Converting Ad Copies',
          '4+ Press Releases (800+ Words Each)',
          'Product Descriptions (50+ Products)',
          'Full Brand Messaging Strategy',
          'Unlimited Revisions',
          'Team of Copywriting Experts',
        ]
      },
    ],

  }
];

export const testimonials = [
  {
    id: 1,
    name: "Marcus Reynolds",
    position: "CTO, Innovexa Systems",
    content: "We needed a custom software solution to streamline our business operations, and Code Commerce delivered beyond expectations. They designed a powerful, scalable system tailored to our unique needs, improving efficiency and productivity. Their technical knowledge and commitment to excellence make them a top choice for any business."
  },
  {
    id: 2,
    name: "Jonathan Hayes",
    position: "CEO, DigitalWave Solutions",
    content: "Code Commerce completely transformed our website, giving it a sleek, modern look with enhanced functionality. The team was highly professional, responsive, and detail-oriented throughout the entire process. Our site's performance and user engagement have significantly improved, making a direct impact on our business growth."
  },
  {
    id: 3,
    name: "Emma Caldwell",
    position: "Product Manager, VisionaryTech Labs",
    content: "The UI/UX design team at Code Commerce delivered an intuitive and visually stunning interface that perfectly aligns with our brand. Their in-depth research and creative approach resulted in a seamless user experience. Our customer engagement has skyrocketed, and we've received outstanding feedback from users."
  },
  {
    id: 4,
    name: "Liam Foster",
    position: "Founder, ChainGuard Technologies",
    content: "Code Commerce built a highly secure and scalable blockchain solution tailored to our business needs. Their technical expertise and innovative approach ensured seamless implementation and top-notch security. The final product exceeded our expectations, helping us establish trust and efficiency in our operations."
  },
  {
    id: 5,
    name: "Sophia Bennett",
    position: "Director of Operations, ElevateCommerce",
    content: "Our e-commerce platform was outdated and slow until we partnered with Code Commerce. They developed a fast, secure, and feature-rich online store that enhanced customer experience and boosted conversions. Their team's expertise in e-commerce solutions helped us stay ahead in a competitive market."
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Basic Website Package",
    price: "499",
    description: "Suitable for potential super-startups and brand revamps for companies.",
    features: [
      "3 Page Website",
      "Custom Layout Design",
      "Contact/Query Form",
      "1 Banner Design",
      "2 Stock Photos",
      "FREE Favicon Design",
      "Cross Browser Compatible",
      "Complete W3C Certified HTML",
      "Website Initial Concepts in 48 Hours",
      "Complete Design & Deployment",
      "Complete Source Files",
      "Dedicated Project Manager",
      "100% Ownership Rights",
      "100% Satisfaction Guarantee",
      "100% Money Back Guarantee"
    ],
    note: "*NO MONTHLY OR ANY HIDDEN FEE*"
  },
  {
    id: 2,
    name: "Startup Website Package",
    price: "899",
    description: "Suitable for potential super-startups and brand revamps for companies.",
    features: [
      "5 Page Website",
      "Custom Layout Design",
      "Contact/Query Form",
      "3 Banner Designs",
      "5 Stock Photos",
      "FREE Favicon Design",
      "FREE Google Friendly Sitemap",
      "Unlimited Revisions",
      "Complete W3C Certified HTML",
      "Website Initial Concepts in 48 Hours",
      "Complete Design & Deployment",
      "Complete Source Files",
      "Dedicated Project Manager",
      "100% Ownership Rights",
      "100% Satisfaction Guarantee",
      "100% Money Back Guarantee"
    ],
    note: "*NO MONTHLY OR ANY HIDDEN FEE*",
    popular: true
  },
  {
    id: 3,
    name: "Professional Website Package",
    price: "1,499",
    description: "Suitable for potential super-startups and brand revamps for companies.",
    features: [
      "Up to 10 Unique Pages Website",
      "CMS /Admin Panel Integration",
      "5+ Stock Photos & Banner Designs",
      "FREE Social Media Integration",
      "FREE Favicon Design",
      "FREE Google Friendly Sitemap",
      "Unlimited Revisions",
      "Cross Browser Compatible",
      "Complete W3C Certified HTML",
      "Website Initial Concepts in 48 Hours",
      "Complete Design & Deployment",
      "Custom, Interactive & Dynamic Web Design",
      "Industry specified Team of Expert Designers and Developers",
      "Complete Source Files",
      "Dedicated Project Manager",
      "100% Ownership Rights",
      "100% Satisfaction Guarantee",
      "100% Money Back Guarantee"
    ],
    note: "*NO MONTHLY OR ANY HIDDEN FEE*"
  }
];

export const blogPosts = [
  {
    id: 1,
    slug: "emerging-trends-software-development",
    title: "Emerging Trends Shaping the Future of Software Development",
    image: "https://images.unsplash.com/photo-1555949963-aa79dcee981c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxzb2Z0d2FyZSUyMGRldmVsb3BtZW50fGVufDB8fHx8MTc2MTg2Njk2N3ww&ixlib=rb-4.1.0&q=85",
    date: "January 15, 2025",
    readTime: "5 min read",
    excerpt: "Explore the cutting-edge trends revolutionizing software development, from AI-powered coding to cloud-native architectures.",
    content: [
      "The software development landscape is undergoing a remarkable transformation. As we move through 2025, emerging technologies and methodologies are reshaping how we build, deploy, and maintain applications.",
      "Artificial Intelligence and Machine Learning are no longer just buzzwords—they're becoming integral parts of the development process. From intelligent code completion to automated testing, AI is enhancing developer productivity at unprecedented levels."
    ],
    sections: [
      {
        heading: "AI-Powered Development Tools",
        paragraphs: [
          "Modern IDEs now incorporate AI assistants that understand context, suggest optimal solutions, and even write entire code blocks. These tools are learning from millions of code repositories to provide developers with intelligent recommendations."
        ],
        bullets: [
          "Intelligent code completion and generation",
          "Automated bug detection and fixing",
          "Smart refactoring suggestions",
          "Natural language to code conversion"
        ]
      },
      {
        heading: "Cloud-Native Architecture",
        paragraphs: [
          "Microservices and containerization have become the standard for building scalable applications. Kubernetes and serverless architectures are enabling developers to focus on code rather than infrastructure management."
        ]
      },
      {
        heading: "Low-Code/No-Code Platforms",
        paragraphs: [
          "These platforms are democratizing software development, allowing non-technical users to build functional applications while freeing developers to focus on complex, high-value tasks."
        ]
      }
    ]
  },
  {
    id: 2,
    slug: "ui-ux-design-business-growth",
    title: "The Impact of UI/UX Design on Business Growth",
    image: "https://images.unsplash.com/photo-1576153192396-180ecef2a715?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxVSSUyMGRlc2lnbnxlbnwwfHx8fDE3NjE4NjY4NjR8MA&ixlib=rb-4.1.0&q=85",
    date: "January 12, 2025",
    readTime: "6 min read",
    excerpt: "Discover how exceptional UI/UX design directly influences customer satisfaction, conversion rates, and overall business success.",
    content: [
      "In today's digital-first world, user experience isn't just a nice-to-have—it's a critical business differentiator. Companies that invest in superior UI/UX design consistently outperform their competitors in customer satisfaction and revenue growth.",
      "Research shows that every dollar invested in UX returns an average of $100, making it one of the highest ROI investments a business can make."
    ],
    sections: [
      {
        heading: "The Business Case for Great Design",
        paragraphs: [
          "Well-designed interfaces reduce customer support costs, increase conversion rates, and build brand loyalty. Companies like Apple and Airbnb have built their success largely on exceptional user experiences."
        ],
        bullets: [
          "75% of users judge credibility based on design",
          "88% of users won't return after a bad experience",
          "Good UX can increase conversion rates by 400%",
          "Mobile-friendly design increases sales by 67%"
        ]
      },
      {
        heading: "Key Design Principles",
        paragraphs: [
          "Successful UI/UX design prioritizes simplicity, consistency, and accessibility. Every interaction should feel natural and intuitive, guiding users effortlessly toward their goals."
        ]
      }
    ]
  },
  {
    id: 3,
    slug: "business-strategies-stay-competitive",
    title: "Essential Strategies for Businesses to Stay Competitive",
    image: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHxkaWdpdGFsJTIwbWFya2V0aW5nfGVufDB8fHx8MTc2MTg2Njg4OXww&ixlib=rb-4.1.0&q=85",
    date: "January 10, 2025",
    readTime: "7 min read",
    excerpt: "Learn the proven strategies that help businesses maintain their competitive edge in rapidly evolving markets.",
    content: [
      "In an era of constant disruption, staying competitive requires more than just keeping pace—it demands innovation, agility, and strategic foresight. Successful businesses are those that anticipate change and adapt proactively.",
      "Digital transformation is no longer optional. Companies must embrace technology not just to survive, but to thrive in the modern marketplace."
    ],
    sections: [
      {
        heading: "Digital-First Approach",
        paragraphs: [
          "Leading companies are putting digital at the core of their business strategy. This means leveraging data analytics, automation, and cloud technologies to optimize operations and enhance customer experiences."
        ]
      },
      {
        heading: "Customer-Centric Innovation",
        paragraphs: [
          "The most successful businesses obsess over customer needs and continuously innovate to meet them. Regular feedback loops and data-driven insights inform product development and service improvements."
        ],
        bullets: [
          "Conduct regular customer research",
          "Implement agile development methodologies",
          "Foster a culture of innovation",
          "Invest in employee development",
          "Build strategic partnerships"
        ]
      }
    ]
  },
  {
    id: 4,
    slug: "boost-ecommerce-sales",
    title: "Proven Methods to Boost E-Commerce Sales",
    image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxlY29tbWVyY2V8ZW58MHx8fHwxNzYxODY2OTE5fDA&ixlib=rb-4.1.0&q=85",
    date: "January 8, 2025",
    readTime: "5 min read",
    excerpt: "Implement these tested strategies to increase your online store's conversion rates and maximize revenue.",
    content: [
      "E-commerce success requires more than just listing products online. It demands a strategic approach to user experience, marketing, and customer service that converts browsers into buyers.",
      "With global e-commerce sales expected to reach $7 trillion in 2025, the competition is fierce. Standing out requires optimization at every touchpoint of the customer journey."
    ],
    sections: [
      {
        heading: "Optimization Strategies",
        bullets: [
          "Streamline the checkout process",
          "Implement personalized recommendations",
          "Optimize for mobile shopping",
          "Use high-quality product images and videos",
          "Offer multiple payment options",
          "Provide excellent customer support",
          "Leverage social proof and reviews"
        ]
      },
      {
        heading: "Marketing Tactics",
        paragraphs: [
          "Effective e-commerce marketing combines SEO, content marketing, social media, and email campaigns. Retargeting abandoned carts and offering limited-time promotions can significantly boost conversion rates."
        ]
      }
    ]
  },
  {
    id: 5,
    slug: "revolutionizing-mobile-app-development",
    title: "Revolutionizing Mobile App Development",
    image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxtb2JpbGUlMjBhcHB8ZW58MHx8fHwxNzYxODY2ODc4fDA&ixlib=rb-4.1.0&q=85",
    date: "January 5, 2025",
    readTime: "6 min read",
    excerpt: "Explore how modern frameworks and tools are transforming the way we build mobile applications.",
    content: [
      "Mobile app development has evolved dramatically in recent years. Cross-platform frameworks, AI integration, and cloud services are enabling developers to build more powerful apps faster than ever before.",
      "The rise of Flutter, React Native, and SwiftUI has made it possible to create beautiful, high-performance apps that work seamlessly across iOS and Android."
    ],
    sections: [
      {
        heading: "Cross-Platform Development",
        paragraphs: [
          "Modern frameworks allow developers to write code once and deploy to multiple platforms, dramatically reducing development time and costs while maintaining native performance."
        ]
      },
      {
        heading: "Emerging Technologies",
        bullets: [
          "5G enabling richer experiences",
          "AR/VR integration",
          "AI-powered features",
          "IoT connectivity",
          "Advanced security measures"
        ]
      }
    ]
  },
  {
    id: 6,
    slug: "digital-marketing-strategies-2025",
    title: "Digital Marketing Strategies for Accelerated Growth in 2025",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxkaWdpdGFsJTIwbWFya2V0aW5nfGVufDB8fHx8MTc2MTg2Njg4OXww&ixlib=rb-4.1.0&q=85",
    date: "January 3, 2025",
    readTime: "8 min read",
    excerpt: "Master the latest digital marketing strategies that drive real results in today's competitive landscape.",
    content: [
      "Digital marketing continues to evolve at a rapid pace. Success in 2025 requires a data-driven approach, authentic content, and seamless integration across multiple channels.",
      "The businesses that thrive are those that understand their audience deeply and deliver personalized experiences at scale."
    ],
    sections: [
      {
        heading: "Content Marketing Excellence",
        paragraphs: [
          "Quality content remains king. Focus on creating valuable, engaging content that solves real problems for your audience. Video content, interactive experiences, and thought leadership pieces drive the most engagement."
        ]
      },
      {
        heading: "Performance Marketing",
        bullets: [
          "Data-driven campaign optimization",
          "Advanced audience targeting",
          "Marketing automation",
          "Conversion rate optimization",
          "Multi-channel attribution",
          "AI-powered personalization"
        ]
      },
      {
        heading: "Social Media Strategy",
        paragraphs: [
          "Social media is no longer just about posting content—it's about building communities, fostering conversations, and creating authentic connections with your audience."
        ]
      }
    ]
  }
];

export const stats = [
  { id: 1, number: "1000+", label: "Successful Projects" },
  { id: 2, number: "950+", label: "Satisfied Clients" },
  { id: 3, number: "1200+", label: "Digital Solutions Delivered" },
  { id: 4, number: "800+", label: "Mobile Applications Developed" }
];